import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "context/AuthContext";
import ClabLogoPng from "components/ui/ClabLogoPng";
import Icon from "components/AppIcon"; // Keep existing Icon import if it's correct for the component
import LoginForm from "pages/login-screen/components/LoginForm";
import LanguageSelector from "pages/login-screen/components/LanguageSelector";
import { getUserDashboardRoute } from "utils/roleUtils";
import { NEXTJS_API_URL } from "utils/api"; // Assuming utils/api is the correct path for NEXTJS_API_URL
import EmployerAccessNotice from "components/ui/EmployerAccessNotice";
import { EMPLOYER_PORTAL_DISABLED } from "config/employerAccess";

const EmployerLogin = () => {
  const navigate = useNavigate();
  const { user } = useAuth(); // Keep this as it's the correct destructuring for user
  const [hasRedirected, setHasRedirected] = useState(false);

  useEffect(() => {
    if (EMPLOYER_PORTAL_DISABLED) {
      return;
    }

    if (user?.id && !hasRedirected) {
      setHasRedirected(true);
      const dashboardRoute = getUserDashboardRoute(user.role);
      navigate(dashboardRoute, { replace: true });
    }
  }, [user?.id, hasRedirected, navigate, user?.role]);

  return (
    <div className="min-h-screen w-full flex flex-col relative bg-[#00939d] md:bg-[url('/assets/employer_login_bg.png')] md:bg-[length:100%_100%] md:bg-center md:bg-no-repeat">
      {/* Header */}
      <header className="relative z-20 w-full px-8 py-4 flex justify-between items-center bg-transparent">
         {/* Empty left side to balance, or just use absolute centering */}
         <div className="w-1/3"></div>
         
         {/* Center - User Manual Link */}
         <div className="w-1/3 flex justify-center">
            <a 
              href={`${NEXTJS_API_URL}/proxy-file?bucket=e-biodata-temp&key=contractor-guide/fixed/eBiodata%20CLAB%20Portal%20(Contractor%20Guideline).pdf`}
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-white/90 hover:text-white bg-white/10 hover:bg-white/20 px-4 py-2 rounded-full backdrop-blur-sm transition-all text-sm font-medium border border-white/20 shadow-sm"
            >
              <Icon name="FileText" size={16} />
              User Manual
            </a>
         </div>

         {/* Right side - Empty or existing content */}
         <div className="w-1/3 flex justify-end">
         </div>
      </header>

      {/* Main Content - Centered on Mobile, Aligned Right on Desktop */}
      <main className="flex-1 flex items-center justify-center md:justify-end px-4 md:px-16 lg:px-24 relative z-10 pb-4">
        <div className="w-full max-w-md">
          <div className="text-center mb-6">
            <img 
              src="/assets/logo_clab_white.png" 
              alt="CLAB Logo" 
              className="h-20 mx-auto mb-2 object-contain"
            />
            <img 
              src="/assets/logo_ebiodata.png" 
              alt="eBiodata Logo" 
              className="h-12 mx-auto mb-2 object-contain drop-shadow-md"
            />
          </div>

          {/* Login Container - Transparent */}
          <div className="p-4">
            <h2 className="text-4xl font-bold text-white text-center mb-6 drop-shadow-md">Employer Login</h2>
            {!EMPLOYER_PORTAL_DISABLED ? (
              <LoginForm selectedLanguage="en" mode="eclab" />
            ) : (
              <div className="rounded-2xl border border-white/20 bg-white/10 p-6 text-center text-white backdrop-blur-sm">
                <Icon name="Lock" size={28} className="mx-auto mb-3" />
                <p className="text-base font-semibold">Akses employer ditutup sementara.</p>
                <p className="mt-2 text-sm text-white/90">
                  Sila rujuk notis pemakluman pada skrin ini untuk maklumat lanjut.
                </p>
              </div>
            )}
            
            <div className="mt-4 text-center">
              <Link
                to="/login-screen"
                className="text-white hover:text-blue-200 underline text-sm font-bold"
              >
                Not Employer? Go to Main Login
              </Link>
            </div>
          </div>

          {/* Footer Info - Specific text provided - Hidden on Mobile */}
          <div className="mt-8 text-right text-xs text-white/90 font-medium leading-relaxed hidden md:block">
             <div className="flex justify-end items-center gap-4 mb-2">
                <span className="flex items-center gap-1"><Icon name="Phone" size={12} /> 03 2095 9599</span>
                <span className="flex items-center gap-1"><Icon name="MessageCircle" size={12} /> 012 694 9599</span>
                <span className="flex items-center gap-1"><Icon name="Mail" size={12} /> vdrclab@clab.com.my</span>
             </div>
             <p className="text-center w-full">Level 2, Annexe, Menara Milenium, No. 8, Jalan Damanlela Bukit Damansara,</p>
             <p className="text-center w-full">Damansara Town Centre, 50490 Kuala Lumpur.</p>
          </div>
        </div>
      </main>

      {EMPLOYER_PORTAL_DISABLED ? <EmployerAccessNotice /> : null}
    </div>
  );
};

export default EmployerLogin;
